export default __webpack_public_path__ + "static/media/wealthsimple.d4f91465.png";